import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pending",
  "use": "icon-pending-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pending\">\r\n<circle cx=\"8\" cy=\"8\" r=\"8\" fill=\"#F79736\" />\r\n<circle cx=\"8\" cy=\"8.5\" r=\"1.5\" fill=\"white\" />\r\n<circle cx=\"12.5\" cy=\"8.5\" r=\"1.5\" fill=\"white\" />\r\n<circle cx=\"3.5\" cy=\"8.5\" r=\"1.5\" fill=\"white\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/pending.svg
// module id = HJAH
// module chunks = 14